import {
  reactive,
  onBeforeMount,
  computed,
  getCurrentInstance,
  watch,
  ref,
} from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import { bannerCriteria } from "@/models/banner/banner";
import tagModel from "@/models/tag/tag-list";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";

export default function useManageCriteriaModal(props) {
  const { fetchBannerCriteriaDetail } = bannerCriteria();

  const { fetchTagList } = tagModel();

  const {
    openErrorModal,
    openSuccessModal,
    openWarningModal,
    openDefaultErrorModal,
  } = useValidationModal();

  const vm = getCurrentInstance().proxy;

  const formData = reactive({
    criteriaGroupId: 0,
    priority: "",
    name: "",
    tag: "",
    note: "",
  });

  const optionData = reactive({
    tagList: [],
  });

  const fetchTagListData = () => {
    window.$loading(true);
    store
      .dispatch("api/apiRequest", fetchTagList)
      .then((resp) => {
        if (resp.data.tag_list.length > 0) {
          optionData.tagList = resp.data.tag_list.map((obj) => ({
            seq: obj.seq,
            label: obj.tag,
          }));
        }
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const fetchDetailData = () => {
    window.$loading(true);
    fetchBannerCriteriaDetail.payload.BannerId = props.formDataObj.bannerId;
    fetchBannerCriteriaDetail.payload.Criteria_Group_Id =
      props.formDataObj.selectId;

    store
      .dispatch("api/apiRequest", fetchBannerCriteriaDetail)
      .then(async (resp) => {
        const respData = resp.data.resp;
        formData.criteriaGroupId = respData.criteria_group_id;
        formData.priority = respData.priority.toString();
        formData.name = respData.name;
        formData.tag =
          respData.tag_list.length > 0
            ? respData.tag_list.map((obj) => ({
                seq: obj.seq,
                label: obj.tag,
                condition: obj.condition,
              }))
            : [];
        formData.note = respData.note;
      })
      .catch((err) => {
        openDefaultErrorModal();
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const onNumberInput = (ev, formDataValue) => {
    vm.$nextTick(() => {
      const inputNumber = ev.replace(/\D/g, "");
      formData[formDataValue] = inputNumber;
    });
  };

  const onSubmitModal = () => {
    vm.$emit("onSubmit", formData, props.isEdit);
  };


  const fetchCriteriaData = () => {
    fetchTagListData();
    if (props.isEdit) {
      fetchDetailData();
    }
  };

  return {
    formData,
    optionData,
    onNumberInput,
    onSubmitModal,
    fetchCriteriaData,
  };
}
